import { getQueryParam } from "@circle-react/helpers/urlHelpers";

export const useVerificationQueryParams = () => {
  const invoiceId = getQueryParam("invoice_id") || "";
  const paymentIntent = getQueryParam("payment_intent") || "";
  const paymentMethodType = getQueryParam("payment_method_type") || "";
  const wasForwarded = !!getQueryParam("forwarded");

  return {
    invoiceId,
    paymentIntent,
    paymentMethodType,
    wasForwarded,
    isVerifiable: !!paymentIntent,
  };
};
